/**
 * Common enum dropdown component connected to formik context
 */
import { forwardRef } from 'react';
import { useField } from 'formik';
import { DefaultItem } from '@adsk/alloy-react-dropdown';
import {
  PureEnumMultiDropdownField,
  PureEnumMultiDropdownFieldProps,
} from './PureEnumMultiDropdownField';
import { useFormikFieldErrorAfterSubmit } from '../useFormikFieldErrorAfterSubmit';

export type EnumMultiDropdownProps = Omit<Partial<PureEnumMultiDropdownFieldProps>, 'fieldName'> &
  Required<Pick<PureEnumMultiDropdownFieldProps, 'fieldName'>>;

export const EnumMultiDropdown = forwardRef<HTMLDivElement, EnumMultiDropdownProps>(
  (props, ref) => {
    const { fieldName } = props;
    const [field, , helpers] = useField(fieldName);
    const error = useFormikFieldErrorAfterSubmit(fieldName);

    const handleSelect = (value: DefaultItem[]) => {
      helpers.setValue(value.map((el) => el.value));
    };

    return (
      <PureEnumMultiDropdownField
        {...props}
        {...field}
        error={error}
        onChange={handleSelect}
        ref={ref}
      />
    );
  },
);
